import { Component, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppState } from '../../../../../../reducers';
import { selectSelectedCompanyData, selectCompanyDatabases } from '../../drill-down.selectors';

@Component({
  selector: 'app-drill-down-section-base',
  template: ``,
})
export class DrillDownSectionBaseComponent implements OnInit, OnDestroy {
  protected companyData: { comparableId: number; uniqueId: number };
  protected databases: any[] = [];

  protected destroy$ = new Subject();

  constructor(protected store: Store<AppState>) {}

  ngOnInit(): void {
    this.store
      .pipe(takeUntil(this.destroy$))
      .pipe(select(selectSelectedCompanyData))
      .subscribe((data) => {
        this.companyData = data;
      });

    this.store
      .pipe(takeUntil(this.destroy$))
      .pipe(select(selectCompanyDatabases))
      .subscribe((dbs) => {
        this.databases = dbs;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next('');
  }

  protected displayValue(value: any): any {
    return !value ? 'N/A' : value;
  }

  protected get hasMultipleDatabases(): boolean {
    return !this.databases ? false : this.databases.length > 1;
  }
}
